"use client";

import Icon from "@/components/library/Icon";
import {cn} from "@/lib/utils";

export default function ToggleChevron({expanded}: Readonly<{expanded: boolean}>) {
   return (
      <Icon
         icon="chevron-down"
         className={cn("h-2.5 w-2.5 transition-transform duration-150", expanded && "rotate-180")}
      />
   );
}
